export enum PaymentDataDiscriminator {
    Alternative = 'Alternative',
    NewPayment = 'NewPayment',
    PaymentCard = 'PaymentCard',
}
